module.exports = __webpack_public_path__ + "img/北京大学深圳医院.174c2e19.png";